import React, { useEffect, useState } from "react";
import Sidebar from "./SideBar";
import TopNavBar from "./topNavBar";
import MobileAppPromptModal from "./MobileAppPromptModal";
import { useUser } from "../contextProviders/userContext";

export const OPEN_MOBILE_PROMPT_EVENT = "wcco:open-mobile-prompt";

const AppShell = ({ children }) => {
  const { user } = useUser();
  const isStudent = user?.role === "student";
  const [showPrompt, setShowPrompt] = useState(false);

  useEffect(() => {
    if (!isStudent) return;

    // Check if dismissed in this login session
    const dismissed = sessionStorage.getItem("wcco_mobile_prompt_dismissed");
    if (!dismissed) {
      const timer = setTimeout(() => {
        setShowPrompt(true);
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [isStudent, user?.id, user?._id]);

  useEffect(() => {
    const handleOpen = () => setShowPrompt(true);
    window.addEventListener(OPEN_MOBILE_PROMPT_EVENT, handleOpen);
    return () => window.removeEventListener(OPEN_MOBILE_PROMPT_EVENT, handleOpen);
  }, []);

  const handleDismiss = () => {
    setShowPrompt(false);
    sessionStorage.setItem("wcco_mobile_prompt_dismissed", "true");
  };

  return (
    <div className="wcco-shell">
      <Sidebar />
      <div className="wcco-shell__main">
        <TopNavBar />
        <main className="wcco-shell__content">{children}</main>
      </div>
      {isStudent && (
        <MobileAppPromptModal show={showPrompt} onHide={handleDismiss} />
      )}
    </div>
  );
};

export default AppShell;
